import client from "./client";

export const searchArtists = (query, signal) =>
  client
    .get(`/spotify/search/${encodeURIComponent(query)}`, { signal })
    .then((r) => r.data);

export const getRecommendations = (artist, id) =>
  client
    .get(
      `/spotify/getRecommendation/${encodeURIComponent(artist)}/${encodeURIComponent(id)}`
    )
    .then((r) => r.data);

export const getComparisons = (artist, recommendations) =>
  client
    .post(`/spotify/get-gpt/${encodeURIComponent(artist)}`, recommendations)
    .then((r) => r.data);
